
import style from "./OrderSummary.module.css"
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import { useParams, useLocation, useNavigate, useOutletContext } from "react-router-dom";
import NiceModal from "@ebay/nice-modal-react";
import { useState, useEffect, useContext, useRef } from "react";

import { BrowserDetectContext } from "providers/BrowserEventProvider";
import CartProduct from "routes/cart/cartLeft/CartProduct";
import SingleSummary from "routes/order/summary/SingleSummary";
import OrderSummaryGuide from "routes/order/summary/OrderSummaryGuide";
import useAltEffect from "shared/hooks/useAltEffect";
import { addCommas, between, calculateDeliveryFee, clone, decode } from "shared/utils/Utils";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faCreditCard, fas } from "@fortawesome/free-solid-svg-icons";
import Inline from "layouts/container/Inline";
import { t } from "i18next";
import FixedHeader from "layouts/container/FIxedHeader";
import BackButton from "components/buttons/BackButton";
import Center from "layouts/wrapper/Center";
import Dummy from "components/Dummy";
import P from "components/P";
import PaddingWrapper from "layouts/wrapper/PaddingWrapper";
import FixedFooter from "layouts/container/FixedFooter";
import ButtonEclipse from "components/buttons/ButtonEclipse";
import visacard from "resources/img/paymentMethod/visa_logo.png";
import mastercard from "resources/img/paymentMethod/mastercard_logo.png";
import alipay from "resources/img/paymentMethod/alipay_logo.jpg";
import wechatpay from "resources/img/paymentMethod/wechatpay_logo.png";
import unionpay from "resources/img/paymentMethod/unionpay_logo.png";
import paypal from "resources/img/paymentMethod/paypal_logo.png";
import { useSelector } from "react-redux";
import OrderProducttRow from "./OrderProducttRow";
import Container from "layouts/container/Container";
import { ToastContainer } from "react-toastify";
import CircleWrapper from "layouts/wrapper/CircleWrapper";
import CIcon from "@coreui/icons-react";
import { cilCreditCard, cilLocationPin } from "@coreui/icons";
import { stubFalse } from "lodash-es";
import { useTranslation } from "react-i18next";
import { ShoppingProcessType } from "shared/constants/constants";
import ShippingInfo from "./ShippingInfo";
import { useDispatch } from "react-redux";
import { CartReducer } from "shared/redux/reducers/shopping/CartReducer";
import checkMark from "resources/img/icons/checkMark.png"
import { AuthContext } from "providers/AuthProvider";
import AccountNo from "../productList/AccountNo";
import HighlightedText from "components/inputs/HighlightedText";

function OrderComplete(props) {
    const location = useLocation(); 
    const { t } = useTranslation();
    
    const navigate = useNavigate();
    const [amount, setAmount] = useState(0);
    // useEffect(() => {
    //     if (location && location.state) {
    //         let orderData = location.state.data;
    //         let selectedShipingOption = location.state.selectedShipingOption;
    //         let usePoint = location.state.usePoint;
    //         setAmount(orderData + selectedShipingOption.price_incl_tax + usePoint);
    //         // setOrderData(orderData);
    //         // setPaymentMethod(paymentMethod);
    //     }
        
    // }, [location]);


    const onOrderDetailClick = () => {
        navigate("/mypage/trackOrder");
    }
    const onGoToHomeClick = () => {
        navigate("/");
    }


    return (
        <VerticalFlex height={"initial"} gap={20} >
            <FlexChild>
                <VerticalFlex gap={30}>
                    <FlexChild>
                        <img src={checkMark} width={"110px"} style={{ filter: "hue-rotate(240deg)", maxWidth: "110px" }} />
                    </FlexChild>
                    <FlexChild>
                        <Container maxWidth={500}>
                            <div>
                                <PaddingWrapper padding={20}>
                                    <VerticalFlex gap={15}>
                                        <FlexChild>
                                            <P weight={"bold"} size={23}>{t("주문완료")}</P>
                                        </FlexChild>
                                        <FlexChild>
                                            <P size={15} weight={'bold'}>
                                                {/* <HighlightedText
                                                    text={`아래의 계좌로 ${amount.toLocaleString()}원을 입금해주시면 결제가 완료됩니다`}
                                                    highlights={[`${amount.toLocaleString()}원`]}
                                                    highlightColor="var(--main-color)"
                                                /> */}
                                            </P>
                                        </FlexChild>
                                        <FlexChild>
                                            <Container >
                                                <div style={{ borderTop: "2px solid #ddd" }}>
                                                    <VerticalFlex>
                                                        <FlexChild>
                                                            {/* <AccountNo /> */}
                                                        </FlexChild>
                                                    </VerticalFlex>
                                                </div>
                                            </Container>
                                        </FlexChild>
                                    </VerticalFlex>
                                </PaddingWrapper>
                            </div>
                        </Container>
                    </FlexChild>
                    <FlexChild justifyContent={"center"}>
                        <HorizontalFlex gap={20}>
                            <FlexChild justifyContent={"flex-end"}>
                                <P onClick={onOrderDetailClick} cursor size={"16px"} padding={"1px 25px"} border={"1px solid #999"}>{t("orderHistory")}</P>
                            </FlexChild>
                            <FlexChild>
                                <P onClick={onGoToHomeClick} cursor weight={"bold"} size={"16px"} padding={"1px 20px"} color={"var(--main-color)"} border={"1px solid var(--main-color)"}>{t("goShopping")}</P>
                            </FlexChild>
                            <FlexChild width={"max-content"}>
                                <Dummy width={"15px"} />
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                </VerticalFlex>
            </FlexChild>
        </VerticalFlex>

    );
}

export default OrderComplete;